<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 427.1 569.9"
  >
    <path
      d="M427.1 214.9c0 141.7-170.1 309.2-206.7 351.8-3.6 4.2-10.1 4.2-13.8 0C170.1 524.1 0 354.1 0 214.9S95.6 1.3 213.6 1.3s213.6 95.6 213.6 213.6Z"
      fill="currentColor"
    />
    <circle cx="213.6" cy="211.8" r="114" style="fill: #fff" />
  </svg>
</template>
